import { Cell } from 'bold-ui'
import { DecimalField, NumberField, resolveName } from 'components/form'
import { getFieldError } from 'components/form/core/util'
import { css } from 'emotion'
import React from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

interface ParticipanteMedicaoFieldProps {
  name: MetaPath<string>
  min: number
  max: number
  maxLength: number
  type: 'decimal' | 'number'
}

export function ParticipanteMedicaoField(props: Readonly<ParticipanteMedicaoFieldProps>) {
  const { name, min, max, maxLength, type } = props

  const { meta } = useField<string>(resolveName(name), {
    subscription: { error: true, touched: true, submitError: true, dirtySinceLastSubmit: true },
  })

  const error = getFieldError(meta)
  const fieldProps = { name, min, max, maxLength, error: null, invalid: !!error }

  return (
    <Cell style={styles.tableCell}>
      {type === 'decimal' ? <DecimalField {...fieldProps} /> : <NumberField {...fieldProps} />}
    </Cell>
  )
}

const styles = {
  tableCell: css`
    padding: 0;
    width: 5.5rem;
  `,
}
